( function () {
    'use strict';
    e.ecom.variants = {};
    e.ecom.variants.init = function () {
        e.ecom.variants.combos = {};
        var jVariantForm = jQuery( '.js-e-variant-form' ),
            jVariantGroups = jVariantForm.find( '.js-e-variantgroup' ),
            productId = jVariantForm.find( '[name = "ProductID"]' ).val();
        if ( jVariantForm.length > 0 ) {
            e.ecom.variants.loadCombos();
            e.ecom.variants.loadOptions( jVariantForm, productId );
            jVariantGroups.on( 'change', function () {
                var variantComboId = e.ecom.variants.getVariantComboId( jVariantForm ),
                    variantComboPartId = '',
                    variantGroupReset = false;
                if ( e.ecom.variants.options[ productId ][ variantComboId ] !== undefined && e.ecom.variants.options[ productId ][ variantComboId ].exists === true ) {
                    e.ecom.variants.setVariantComboId( jVariantForm, variantComboId );
                    e.ecom.variants.setVariantDetails( jVariantForm, productId, variantComboId );
                }
                //else {
                jVariantGroups.each( function () {
                    var jThisSelect = jQuery( this );
                    if ( variantGroupReset === true ) {
                        jThisSelect.find( 'option' ).prop( 'disabled', false );
                        jThisSelect.val( '' );
                    }
                    else {
                        jThisSelect.find( 'option' ).not( '[value=""]' ).each( function () {
                            var jThisOption = jQuery( this ),
                                thisOptionValue = jThisOption.attr( 'value' );
                            //If variantCombo doesn't exsist in options obejct we can if it is selctable
                            if ( e.ecom.variants.options[ productId ][ variantComboPartId + thisOptionValue ] !== undefined ) {
                                jThisOption.prop( 'disabled', !e.ecom.variants.options[ productId ][ variantComboPartId + thisOptionValue ].selectable );
                            }
                            //If not, it is not selectable
                            else {
                                jThisOption.prop( 'disabled', true );
                            }
                            //If the option is disabled it cannot be selected and the select element must reseted as does all the following selectes
                            if ( jThisOption.prop( 'disabled' ) === true && jThisOption.prop( 'selected' ) === true ) {
                                jThisSelect.val( '' );
                                variantGroupReset = true;
                            }
                        } );
                    }
                    variantComboPartId += jThisSelect.val() + '.';
                } );
            } ).last().triggerHandler( 'change' );
        }
    };
    e.ecom.variants.loadOptions = function ( jVariantForm, productId ) {
        e.ecom.variants.options = {};
        e.ecom.variants.groups = [];
        jVariantForm.find( '.js-e-variantgroup' ).each( function ( index ) {
            var jThisVariantGroup = jQuery( this ),
                loopGroupIndex = index;
            e.ecom.variants.groups[ loopGroupIndex ] = [];
            jThisVariantGroup.find( 'option' ).not( '[value=""]' ).each( function () {
                e.ecom.variants.groups[ loopGroupIndex ].push( this.value );
            } );
        } );
        e.ecom.variants.options[ productId ] = {};
        if ( e.ecom.variants.groups.length > 0 ) {
            for ( var i = 0; i < e.ecom.variants.groups[ 0 ].length; i++ ) {
                e.ecom.variants.options[ productId ][ e.ecom.variants.groups[ 0 ][ i ] ] = e.ecom.variants.buildOptionObject( productId, e.ecom.variants.groups[ 0 ][ i ], 1 );
            }
        }
        e.ecom.variants.setAvailablity( productId );
    };
    e.ecom.variants.buildOptionObject = function ( productId, parent, index ) {
        var option = {
            exists: false,
            selectable: false,
            options: index === e.ecom.variants.groups.length ? [] : e.ecom.variants.groups[ index ]
        };
        for ( var i = 0; i < option.options.length; i++ ) {
            var variantId = parent + '.' + option.options[ i ];
            e.ecom.variants.buildOptionObject( productId, variantId, index + 1 );
        }
        e.ecom.variants.options[ productId ][ parent ] = option;
        return option;
    };
    e.ecom.variants.setAvailablity = function ( productId ) {
        jQuery.each( e.ecom.variants.options[ productId ], function ( optionId ) {
            if ( e.ecom.variants.combos[ productId ][ optionId ] !== undefined ) {
                e.ecom.variants.options[ productId ][ optionId ].exists = true;
                e.ecom.variants.options[ productId ][ optionId ].selectable = true;
            }
            else {
                for ( var combo in e.ecom.variants.combos[ productId ] ) {
                    if ( combo.indexOf( optionId + '.' ) === 0 ) {
                        e.ecom.variants.options[ productId ][ optionId ].selectable = true;
                        break;
                    }
                }
            }
        } );
    };
    e.ecom.variants.loadCombos = function () {
        eval( jQuery( '.js-e-variantcombinations' ).html() );
    };
    e.ecom.variants.getVariantComboId = function ( jVariantForm ) {
        var variantId = '';
        jVariantForm.find( '.js-e-variantgroup' ).each( function () {
            variantId += '.' + jQuery( this ).val();
        } );
        return variantId.substring( 1 );
    };
    e.ecom.variants.setVariantComboId = function ( jVariantForm, variantComboId ) {
        jVariantForm.find( '[name = "VariantID"]' ).val( variantComboId );
    };
    e.ecom.variants.setVariantDetails = function ( jVariantForm, productId, variantComboId ) {
        var variant = e.ecom.variants.combos[ productId ][ variantComboId ],
            variantInStock = parseInt( variant.ProductStock, 10 ) > 0,
            jVariantImage = jVariantForm.find( '.js-e-image' );
        jVariantImage.attr( 'href', e.dw.buildImageURL( variant.ProductImage, '1200', 'auto' ) );
        jVariantImage.attr( 'src', e.dw.buildImageURL( variant.ProductImage, 'auto', jVariantImage.width() ) );
        jVariantForm.find( '.js-e-number' ).html( variant.ProductNumber );
        e.ecom.updatePrice( jVariantForm );
        jVariantForm.find( '.js-e-stock-in' ).toggle( variantInStock === true );
        jVariantForm.find( '.js-e-stock-out' ).toggle( variantInStock === false );
        jVariantForm.find( '.js-e-stock-text' ).text( variant.ProductStockStateText );
        jVariantForm.find( '.js-e-stock-deliverytext' ).text( variant.ProductStockDeliveryText );
    };
}() );
